import { Plugins } from '@leverege/plugin';

/**
 * A comparator function that compares a.sort and b.sort, assuming
 * a.sort and b.sort are numbers 
 */
function numSortComparator(a, b) {
  const an = a.sort || 0;
  const bn = b.sort || 0;
  return an - bn;
}

/**
 * Returns a sorted array of plugins
 */
function sortedPlugins(pluginType, filter) {
  const plgs = [...Plugins.get(pluginType, filter)];
  plgs.sort(numSortComparator);
  return plgs;
}
async function invokeMoltenCallbacks(pluginType, method, molten, ...rest) {
  const callbacks = sortedPlugins(pluginType);
  for (let n = 0; n < callbacks.length; n++) {
    // eslint-disable-next-line no-await-in-loop
    await callbacks[n][method](molten, ...rest);
  }
}
function adjustPath(path) {
  if (typeof path === 'string' && path[0] === '/') {
    const base = window.Molten.getConfig('baseUrl', null);
    if (base == null || base[0] !== '/' || path.startsWith(base)) {
      return path;
    }
    if (path === '/') {
      return base;
    }
    return base + path;
  }
  if (Array.isArray(path)) {
    return path.map(s => adjustPath(s));
  }
  return path;
}
export default {
  numSortComparator,
  sortedPlugins,
  invokeMoltenCallbacks,
  adjustPath
};